/**
 * Real photography rendered inside the same elegant framing used across the
 * site (replaces PremiumPlaceholder where client photos are available).
 * `aspect` is a CSS aspect-ratio string, e.g. "4 / 5".
 */
export default function FramedPhoto({ src, alt, aspect = "4 / 5", className = "", testId }) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`relative block w-full object-cover ${className}`}
      style={{ aspectRatio: aspect }}
      data-testid={testId}
    />
  );
}
